// extracted by mini-css-extract-plugin
module.exports = {"btn__container":"BackButton_btn__container__D0opn","back__btn":"BackButton_back__btn__ccaFM"};